/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Optional. The history of the conversation.
 * @export
 * @interface ChatMessageInput
 */
export interface ChatMessageInput {
    /**
     * The role of the message sender.
     * @type {string}
     * @memberof ChatMessageInput
     */
    role: ChatMessageInputRoleEnum;
    /**
     * The content of the message.
     * @type {string}
     * @memberof ChatMessageInput
     */
    content: string;
}


/**
 * @export
 */
export const ChatMessageInputRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
} as const;
export type ChatMessageInputRoleEnum = typeof ChatMessageInputRoleEnum[keyof typeof ChatMessageInputRoleEnum];


/**
 * Check if a given object implements the ChatMessageInput interface.
 */
export function instanceOfChatMessageInput(value: object): value is ChatMessageInput {
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ChatMessageInputFromJSON(json: any): ChatMessageInput {
    return ChatMessageInputFromJSONTyped(json, false);
}

export function ChatMessageInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatMessageInput {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'],
        'content': json['content'],
    };
}

export function ChatMessageInputToJSON(json: any): ChatMessageInput {
    return ChatMessageInputToJSONTyped(json, false);
}

export function ChatMessageInputToJSONTyped(value?: ChatMessageInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': value['role'],
        'content': value['content'],
    };
}

